import { makeStyles } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import { get } from 'lodash'
import { EMPTY_MSG_NO_PRODUCTS } from 'src/utils/constants/RiskCategory'

const RiskCategoryContentItem = ({
  heading,
  dataArray,
  keyLabel,
  custClass = '',
  emptyDataMessage = EMPTY_MSG_NO_PRODUCTS,
  hasClickEvent = false,
  handleClick,
}) => {
  const classes = useStyles()

  const handleOnclick = (e, insurance) => {
    if (!hasClickEvent) return
    handleClick(insurance)
  }

  return (
    <>
      <h3>{heading}</h3>
      {dataArray?.length === 0 ? (
        <span className={classes.emptyData}>{emptyDataMessage}</span>
      ) : (
        <div className={classes.tilesWrapper}>
          {dataArray?.map((d) => {
            const imgUrl = get(d, 'image', '')
            const insuranceName = get(d, 'insuranceName', '')
            const productSubType = get(d, 'productSubType', '')
            return (
              <div
                id='insuranceDetails'
                aria-hidden='true'
                key={`${keyLabel}-${d?.insuranceName}`}
                className={`${classes.tileCard} ${custClass ?? ' '}`}
                onClick={(e) => handleOnclick(e, d)}
              >
                <div className={classes.icon}>
                  <img src={imgUrl} alt={insuranceName} />
                </div>
                <div className={classes.title}>
                  {insuranceName ? insuranceName : productSubType}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </>
  )
}

export default RiskCategoryContentItem

export const useStyles = makeStyles({
  tilesWrapper: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: '14px',
    alignItems: 'center',
    justifyContent: 'center',
    color: COLORS.GREY,
    padding: '8px 8px',
    background: COLORS.WHITE,
  },
  tileCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px 24px',
    borderRadius: '10px',
    margin: '0px 10px 22px',
    cursor: 'pointer',
    minHeight: '48px',
    maxWidth: '230px',
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    backgroundColor: COLORS.WHITE,
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.15)',
    '&:hover': {
      border: `1px solid ${COLORS.DARK_PINK}`,
      color: COLORS.DARK_PINK,
    },
    border: `1px solid ${COLORS.WHITE}`,
  },

  icon: {
    width: '26px',
    margin: '0 8px 0 0',
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    '& img': {
      maxWidth: '100%',
    },
  },
  title: {
    fontSize: '14px',
    lineHeight: '16px',
    color: 'inherit',
    boxSizing: 'border-box',
    fontWeight: 500,
  },
  emptyData: {
    fontSize: '12px',
    color: '#ababab',
    marginTop: '20px',
    display: 'inline-block',
  },
})
